"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var OpenButton_1 = tslib_1.__importDefault(require("../../components/OpenButton"));
var Sidebar_1 = tslib_1.__importDefault(require("../Sidebar"));
var PagesApi_1 = tslib_1.__importDefault(require("../../PagesApi"));
var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  position: fixed;\n  right: 32px;\n  bottom: 32px;\n  z-index: 10000;\n"], ["\n  position: fixed;\n  right: 32px;\n  bottom: 32px;\n  z-index: 10000;\n"])));
var App = /** @class */ (function (_super) {
    tslib_1.__extends(App, _super);
    function App(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            opened: false,
            settings: null
        };
        _this.loadSettings = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var appSpace, response, contactFormSettings, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        appSpace = this.props.appSpace;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, PagesApi_1["default"].publicGetSettings(appSpace)];
                    case 2:
                        response = _a.sent();
                        contactFormSettings = response.contactForm || null;
                        this.setState({ settings: contactFormSettings });
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.setState({ settings: null });
                        console.error("Unable to fetch setting for appspace ".concat(appSpace));
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.handleDocumentKeyUp = function (ev) {
            if (ev.keyCode === 27) {
                // ESC key
                _this.setState({ opened: false });
            }
        };
        _this.handleClickBtn = function () {
            _this.setState(function (prevState) { return ({
                opened: !prevState.opened
            }); });
        };
        _this.handleClose = function () {
            _this.setState({ opened: false });
        };
        PagesApi_1["default"].setBaseUrl(props.pagesApiBaseUrl || 'https://pages.sportnet.online/api/v1');
        return _this;
    }
    App.prototype.componentDidMount = function () {
        this.loadSettings();
        document.addEventListener('keyup', this.handleDocumentKeyUp);
    };
    App.prototype.componentWillUnmount = function () {
        document.removeEventListener('keyup', this.handleDocumentKeyUp);
    };
    App.prototype.render = function () {
        var appSpace = this.props.appSpace;
        var _a = this.state, opened = _a.opened, settings = _a.settings;
        if (settings) {
            return (react_1["default"].createElement(Wrapper, null,
                react_1["default"].createElement(OpenButton_1["default"], { onClick: this.handleClickBtn }),
                react_1["default"].createElement(Sidebar_1["default"], { appSpace: appSpace, opened: opened, onClose: this.handleClose, subjects: settings.subject, description: settings.description })));
        }
        return null;
    };
    return App;
}(react_1.Component));
exports["default"] = App;
var templateObject_1;
